module.exports = __webpack_public_path__ + "img/success.b9d04f16.png";